// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Burger-module--wrap--22A4l","open":"Burger-module--open--kGw9k"};